<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    Despesas Parceiro
                </span>
            </b-card-header>
            <b-card-body>
                <div>
                    <app-erros-box
                        :erros="erros"
                        v-if="erros.length > 0"
                    ></app-erros-box>
                    <app-tabela
                        :itens="despesasParceiro"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false">
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-inserir-despesa-parceiro
                                :pleito="pleito"
                                class="mr-2"
                                :dataServicos="dataServicos"
                                @atualizarLista="atualizarLista()">
                            </btn-inserir-despesa-parceiro>
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                            <btn-excluir-despesa-parceiro
                                :pleito="pleito"
                                class="text-danger float-left mr-1"
                                :despesaParceiro="data"
                                :dataServicos="dataServicos"
                                @atualizarLista="atualizarLista()">
                            </btn-excluir-despesa-parceiro>
                    </template>
                    <template slot="proposta" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.proposta }}
                        </p>
                    </template>
                    <template slot="nomeAcao" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.nomeAcao }}
                        </p>
                    </template>
                    <template slot="descritivo" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.descritivo }}
                        </p>
                    </template>
                    <template slot="valorTotal" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.valorTotal }}
                        </p>
                    </template>
                    <template slot="tipoNaturezaDesc" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.tipoNaturezaDesc }}
                        </p>
                    </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>
    
<script>
import BtnInserirDespesaParceiro from './BtnInserirDespesaParceiro'
import BtnExcluirDespesaParceiro from './BtnExcluirDespesaParceiro'

export default {
    components: {
        BtnInserirDespesaParceiro,
        BtnExcluirDespesaParceiro
    },

    props: {
        dataServicos: {
            type: Object
        },
        pleito: {
            type: Object,
        },
        pleitoDespesasParceiro: {
            type: Array,
        }
    },

    data() {
        return {
            erros: [],
            despesasParceiro: [],
            despesaParceiro:null,
            itensPorPagina: 5,
            campos: [
                {
                    key: 'proposta',
                    label: 'Proposta',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descritivo',
                    label: 'Descritivo',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nomeAcao',
                    label: 'Nome da Ação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'tipoNaturezaDesc',
                    label: 'Natureza',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],

        }
    },

    methods:{
        atualizarLista() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterDespesasParceiro(this.$route.params.pleitoId).then((response) => {
            if (response) {
                if (response.success) {
                    this.despesasParceiro = response.data
                } else {
                    this.erros = response.errors
                }
            }
            this.$store.dispatch('removeRequest')
            })
        },
    },
    mounted() {
        this.despesasParceiro = this.pleitoDespesasParceiro
    }
}
</script>
